export const environment = {
  production: true,
  apiUrl: (window as any).config?.API_URL || 'https://api.walkout.eu',
};
